import * as Yup from 'yup';

export interface OrbitCallInfoValues {
    callId: string;
}

export const initialValues: OrbitCallInfoValues = {
    callId: '',
};

export const validationSchema = Yup.object({
    callId: Yup.string().max(
        100,
        'El call ID debe tener 100 caracteres alfanuméricos como máximo'
    ),
});
